<template>
    <el-container style="height: 100%">
        <el-main style="padding: 0; height: 2690px;overflow: hidden;">
            <div ref="section1" class="section">
                <el-dropdown trigger="click" @command="handleCommand" v-if="!isMobile">
                    <span class="el-dropdown-link">
                        <svg class="icon"
                            style="width: 100%;height: 100%;vertical-align: middle;fill: currentColor;overflow: hidden;"
                            viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6183">
                            <path
                                d="M981.3 213.3H42.7C19.1 213.3 0 194.2 0 170.7S19.1 128 42.7 128h938.7c23.6 0 42.7 19.1 42.7 42.7s-19.2 42.6-42.8 42.6zM981.3 554.7H42.7C19.1 554.7 0 535.6 0 512s19.1-42.7 42.7-42.7h938.7c23.6 0 42.7 19.1 42.7 42.7s-19.2 42.7-42.8 42.7zM981.3 896H42.7C19.1 896 0 876.9 0 853.3s19.1-42.7 42.7-42.7h938.7c23.6 0 42.7 19.1 42.7 42.7-0.1 23.6-19.2 42.7-42.8 42.7z"
                                p-id="6184">
                            </path>
                        </svg>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item icon="el-icon-upload2" :command="1">主营业务</el-dropdown-item>
                        <el-dropdown-item icon="el-icon-star-off" :command="2">典型案例</el-dropdown-item>
                        <el-dropdown-item icon="el-icon-phone-outline" :command="3">联系我们</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <MainView></MainView>
            </div>
            <div ref="section2" style="background-color: #1a1a1a" :style="{ height: isMobile ? '1200px' : '100vh' }">
                <CaseView></CaseView>
            </div>
            <div ref="section3" style="height: 945px;background-color: #1a1a1a">
                <ContactView></ContactView>
            </div>
        </el-main>
    </el-container>
</template>

<script>
import CaseView from "./CaseView.vue";
import ContactView from "./Contact.vue";
import MainView from "./MainView.vue";
export default {
    components: { MainView, CaseView, ContactView },
    data() {
        return {
            currentSection: 0,
            sections: [],
            isScrolling: false,
            scrollListener: null,
            lastScrollTime: 0,
            throttleInterval: 300,
            scrollDuration: 500,
            isScrollDisabled: true,
            isMobile: false
        };
    },
    mounted() {
        this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        window.addEventListener("resize", this.checkDeviceType);

        if (!this.isMobile) {
            this.sections = [
                this.$refs.section1,
                this.$refs.section2,
                this.$refs.section3
            ];
            this.scrollListener = this.handleScroll.bind(this);
            window.addEventListener("wheel", this.scrollListener, {
                passive: false
            });
        }
    },
    beforeDestroy() {
        if (!this.isMobile) {
            window.removeEventListener("wheel", this.scrollListener);
        }
        window.removeEventListener("resize", this.checkDeviceType);
    },
    watch: {
        currentSection() {
            // console.log(this.scrollListener);
        }
    },
    methods: {
        handleCommand(command) {
            if (command >= 1 && command <= 3) {
                this.currentSection = command - 1;
                this.scrollToSection(this.currentSection);
            }
        },
        checkDeviceType() {
            this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        },
        handleScroll(event) {
            const now = Date.now();
            if (now - this.lastScrollTime < this.throttleInterval || this.isScrolling) {
                return;
            }
            this.lastScrollTime = now;
            event.preventDefault();
            const delta = Math.sign(event.deltaY);

            let newSection = this.currentSection;
            if (delta > 0 && newSection < this.sections.length - 1) {
                newSection++;
            } else if (delta < 0 && newSection > 0) {
                newSection--;
            } else {
                return;
            }

            if (newSection === this.currentSection) {
                return;
            }

            this.isScrolling = true;
            this.currentSection = newSection;
            this.scrollToSection(newSection);
        },
        scrollToSection(sectionIndex) {
            const targetSection = this.sections[sectionIndex];
            targetSection.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });

            document.addEventListener("wheel", this.preventScroll, {
                passive: false
            });
            document.addEventListener("touchmove", this.preventScroll, {
                passive: false
            });

            setTimeout(() => {
                this.isScrolling = false;
                document.removeEventListener("wheel", this.preventScroll);
                document.removeEventListener("touchmove", this.preventScroll);
            }, this.scrollDuration);
        },
        preventScroll(event) {
            event.preventDefault();
        }
    }
};
</script>

<style scoped lang="scss">
.section {
    height: 800px;
    position: relative;

    // .icon {
    //     position: absolute;
    //     top: 60px;
    //     right: 100px;
    //     z-index: 100;
    //     border-radius: 50px;
    //     width: 50px;
    //     height: 50px;
    //     cursor: pointer;
    // }

}

::v-deep .el-dropdown {
    width: 50px;
    height: 50px;
    position: fixed;
    top: 60px;
    right: 100px;
    z-index: 100;

    .icon {
        cursor: pointer;
    }
}

@media (max-width: 798px) {
    .section {
        height: auto;
    }
}
</style>